import { render, staticRenderFns } from "./priceDetail.vue?vue&type=template&id=87d17eea&scoped=true"
import script from "./priceDetail.vue?vue&type=script&lang=js"
export * from "./priceDetail.vue?vue&type=script&lang=js"
import style0 from "./priceDetail.vue?vue&type=style&index=0&id=87d17eea&prod&scoped=true&lang=css"
import style1 from "./priceDetail.vue?vue&type=style&index=1&id=87d17eea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d17eea",
  null
  
)

export default component.exports